import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
import { Search } from '@element-plus/icons-vue';
import { onMounted, reactive, ref } from "vue";
import apis from "@/api";
import { ElMessage, ElMessageBox } from "element-plus";
import _ from 'lodash';
import { listPersonnel, updatePersonnel } from "../../../../api/modules/advert";
export default {
  __name: 'ContractAdd',
  props: {
    title: {
      type: String,
      default: '添加合同',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    adminArea: {
      type: String,
      default: '-1'
    }
  },
  emits: ['success', 'update:visible'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    const props = __props;
    const data = reactive({
      form: {},
      suppliers: [],
      types: [{
        typeName: '广告投放',
        typeValue: 0
      }, {
        typeName: '活动宣传',
        typeValue: 1
      }, {
        typeName: '媒介监测',
        typeValue: 2
      }],
      role: {},
      userList: [],
      userShow: false,
      checkUser: [],
      areaCode: ""
    });
    const elLoading = ref(false);
    const handleQueryContract = () => {
      if (!data.form.contractCode) {
        ElMessage.error('请先输入合同编码!');
        return;
      }
      elLoading.value = true;
      apis.getContractInfo({
        contractNo: data.form.contractCode
      }).then(res => {
        if (res.respCode == 0 && res.respDesc == "ok") {
          data.form.contractName = res.result.OUTPUTCOLLECTION_ITEM[0].CONTRACT_NAME;
          data.form.contractCode = res.result.OUTPUTCOLLECTION_ITEM[0].CONTRACT_NO;
          data.form.contractAmount = res.result.OUTPUTCOLLECTION_ITEM[0].AMOUNT_ADJUST_INCLUDING_TAX;
          data.form.startDate = res.result.OUTPUTCOLLECTION_ITEM[0].START_DATE;
          data.form.endDate = res.result.OUTPUTCOLLECTION_ITEM[0].END_DATE;
        } else {
          ElMessage.error("未查到合同信息!");
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const close = () => {
      data.form = {};
      emits('update:visible', false);
    };
    const handleSupplierChange = () => {
      data.checkUser = [];
      data.role = _.find(data.suppliers, o => {
        return o.roleId === data.form.supplierId;
      });
      data.form.supplier = data.role.roleName;
      getRolesUserList();
    };
    const querySupplier = () => {
      const roleId = "vendor_src_";
      elLoading.value = true;
      apis.getChildrenList(roleId).then(res => {
        if (res.success) {
          data.suppliers = res.data;
          if (data.suppliers && data.suppliers.length != 0) {
            const parentRoleId = data.suppliers[0].parentRoleId;
            data.areaCode = parentRoleId.substring(parentRoleId.length - 4);
          }
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const getRolesUserList = () => {
      if (data.form.supplierId != null) {
        data.userShow = true;
      }
      const roleId = data.form.supplierId;
      if (roleId != null) {
        return apis.getRolesUserList(roleId).then(res => {
          if (res.success) {
            data.userList = res.data;
          } else {
            ElMessage.error(res.msg);
          }
        }).catch(err => {
          ElMessage.error(err);
        }).finally(() => {
          elLoading.value = false;
        });
      }
      return Promise.resolve();
    };
    const initEdit = async row => {
      data.form = row;
      await getRolesUserList();
      data.checkUser = [];
      // 回显多选项
      apis.listPersonnel({
        contractId: row.id
      }).then(res => {
        if (res.success) {
          for (let i = 0; i < res.data.length; i++) {
            for (let j = 0; j < data.userList.length; j++) {
              if (data.userList[j].userId === res.data[i]) {
                data.checkUser.push(data.userList[j]);
              }
            }
          }
        }
      }).catch(err => {
        ElMessage.error(err);
      });
    };
    const handleEditContract = () => {
      if (data.checkUser.length === 0) {
        ElMessage.error("请选择至少一位联系人！");
        return;
      }
      let supplierName = '';
      for (let supplier of data.suppliers) {
        if (supplier.roleId === data.form.supplierId) {
          supplierName = supplier.roleName;
          break;
        }
      }
      const params = {
        contractId: data.form.id,
        supplierId: data.form.supplierId,
        supplier: supplierName,
        contractType: data.form.contractType
      };
      apis.updatePersonnel(data.checkUser, params).then(res => {
        if (res.success) {
          ElMessage.success("修改成功!");
          emits("success");
        }
      }).finally(() => {
        data.userShow = false;
        elLoading.value = false;
        close();
      });
    };
    const handleSaveContract = () => {
      if (props.edit) {
        handleEditContract();
        return;
      }
      if (!data.form.supplierId) {
        ElMessage.error("请选择供应商！");
        return;
      }
      if (!data.form.contractCode) {
        ElMessage.error("请输入合同编号");
        return;
      }
      if (!data.form.contractName) {
        ElMessage.error("请先查询合同信息!");
        return;
      }
      if (data.checkUser.length == 0) {
        ElMessage.error("请选择联系人！");
        return;
      }
      if (isNaN(parseFloat(data.form.contractType))) {
        ElMessage.error("请选择合同类型！");
        return;
      }
      data.form.settlementState = 3;
      elLoading.value = true;
      data.form.areaCode = data.areaCode;
      apis.addContractInfo(data.form).then(res => {
        if (res.success) {
          data.checkUser.forEach(function (item) {
            item.contractId = res.data.id;
            item.status = 1;
            item.id = null;
          });
          apis.addContractPersonnelInfo(data.checkUser).then(res => {
            ElMessage.success("添加成功!");
            emits("success");
          });
        } else {
          if (!res.data) {
            ElMessage.error(res.msg);
            return;
          }
          if (res.data.areaCodeList.indexOf(props.adminArea) >= 0) {
            ElMessage.error('已添加过该合同');
            return;
          }
          ElMessageBox.confirm('该合同已由其他地区添加，是否在本地区关联上该合同？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            res.data.areaCodeList = res.data.areaCodeList + ',' + props.adminArea;
            apis.updateContractInfo(res.data).then(result => {
              if (result.success) {
                ElMessage.success('添加成功');
                emits("success");
              } else {
                ElMessage.success('添加失败');
              }
            });
          });
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        data.userShow = false;
        elLoading.value = false;
        close();
      });
    };
    onMounted(() => {
      querySupplier();
    });
    __expose({
      initEdit
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        width: "40%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSaveContract
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("保存", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          model: data.form,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "合同编码",
            prop: "contractCode"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.contractCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.form.contractCode = $event),
              placeholder: "请输入合同编码",
              disabled: __props.edit
            }, {
              append: _withCtx(() => [_createVNode(_component_el_button, {
                icon: _unref(Search),
                onClick: handleQueryContract,
                disabled: __props.edit
              }, null, 8, ["icon", "disabled"])]),
              _: 1
            }, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "合同名称",
            prop: "contractName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.contractName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.form.contractName = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "合同金额",
            prop: "contractAmount"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.contractAmount,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.form.contractAmount = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "合同生效时间",
            prop: "startDate"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.startDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.form.startDate = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "合同失效时间",
            prop: "endDate"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.endDate,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.form.endDate = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "合同类型",
            prop: "endDate"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: data.form.contractType,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => data.form.contractType = $event),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.types, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.typeName,
                  value: item.typeValue
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "供应商",
            prop: "supplierId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: data.form.supplierId,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => data.form.supplierId = $event),
              placeholder: "请选择",
              onChange: handleSupplierChange
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.suppliers, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.roleName,
                  value: item.roleId
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), data.userShow ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "联系人"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: data.checkUser,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.checkUser = $event),
              multiple: "",
              placeholder: "请选择",
              "value-key": "id",
              change: "changeValue"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.userList, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])), [[_directive_loading, elLoading.value]])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};